import { render, staticRenderFns } from "./DeafService.vue?vue&type=template&id=f6cfc1c0&scoped=true"
import script from "./DeafService.vue?vue&type=script&lang=js"
export * from "./DeafService.vue?vue&type=script&lang=js"
import style0 from "./DeafService.vue?vue&type=style&index=0&id=f6cfc1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cfc1c0",
  null
  
)

export default component.exports